"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _i18n = require("../../i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function tt(props, key) {
  var t = props.t,
      language = props.language;
  return t(key, {
    lng: language
  });
}

var Loading = function Loading(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'card'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'card-block'
  }, props.message || tt(props, 'loading')));
};

Loading.propTypes = {
  language: _propTypes["default"].string,
  message: _propTypes["default"].any
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(Loading);

exports["default"] = _default;